export default
{
    components:
    {

    },

    props:
    {

    },

    created()
    {

    },

    mounted()
    {
        setTimeout(() =>
        {
            this.$el.classList.add('is-active')
        }, 5000)

        setTimeout(() =>
        {
            this.onClose()
        }, 25000)
    },

    destroyed()
    {

    },

    methods:
    {
        onClose()
        {
            this.$emit('tooltip:close')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-tooltip-selection/script.js